export type Segment = {
  key: string;
  label: string;
  /** The segment's size; zero or less leaves it out of the bar. */
  value: number;
  /** How the amount reads in the legend, e.g. "$825". */
  amount: string;
  tone: "spent" | "saved" | "fee" | "covered";
};

/** One total split into its parts: proportional segments on a bar, the
 * parts and their amounts in a legend underneath. */
export function SegmentBar({
  segments,
  label,
}: {
  segments: Segment[];
  label: string;
}) {
  const shown = segments.filter((s) => s.value > 0);
  return (
    <div className="ds-segbar">
      <div
        className="ds-segbar-bar"
        role="img"
        aria-label={`${label}: ${segments.map((s) => `${s.label} ${s.amount}`).join(", ")}`}
      >
        {shown.map((s) => (
          <span
            key={s.key}
            className={`ds-seg ${s.tone}`}
            style={{ flexGrow: s.value }}
          />
        ))}
      </div>
      <dl className="ds-segbar-legend">
        {segments.map((s) => (
          <div key={s.key}>
            <dt>
              <i className={`ds-seg ${s.tone}`} aria-hidden />
              {s.label}
            </dt>
            <dd>{s.amount}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
}
